import React, { useState, useRef } from 'react';

// Small, dependency-free voice-search button using the browser's built-in
// Web Speech API. Sits next to an existing search input -- it never
// replaces typing, it just fills in the same search box by voice and lets
// the page's own onResult callback decide what to do (normally: update the
// search field and re-run the existing search).
//
// Support is uneven across browsers (solid on Chrome desktop/Android, weak
// or missing on Safari/iOS and Firefox) -- rather than show a button that
// silently fails there, we return null and the button just doesn't render,
// leaving the existing typed search untouched.
export default function VoiceSearchButton({ onResult, lang }) {
  var _listening = useState(false), listening = _listening[0], setListening = _listening[1];
  var recognitionRef = useRef(null);

  var SpeechRecognition = typeof window !== 'undefined' && (window.SpeechRecognition || window.webkitSpeechRecognition);
  if (!SpeechRecognition) return null;

  function handleClick() {
    if (listening) {
      if (recognitionRef.current) recognitionRef.current.stop();
      return;
    }
    var recognition = new SpeechRecognition();
    // en-IN reads Indian names/places more accurately than the default
    // en-US model.
    recognition.lang = lang || 'en-IN';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    recognition.onresult = function(e) {
      var transcript = e.results[0][0].transcript;
      onResult(transcript);
    };
    recognition.onerror = function() { setListening(false); };
    recognition.onend = function() { setListening(false); };
    recognitionRef.current = recognition;
    setListening(true);
    recognition.start();
  }

  return React.createElement('button', {
    type: 'button',
    onClick: handleClick,
    title: listening ? 'Listening... click to stop' : 'Search by voice',
    style: {
      padding: '10px 14px',
      background: listening ? '#dc2626' : '#e5e7eb',
      color: listening ? 'white' : '#374151',
      border: 'none',
      borderRadius: 8,
      cursor: 'pointer',
      fontSize: 16,
      lineHeight: 1,
      flexShrink: 0
    }
  }, listening ? '⏹️' : '\u{1F3A4}');
}
